'use client'

import type { MenuItem, MenuSeparator } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

export const DEFAULT_PROFILE_ITEMS: (MenuItem | MenuSeparator)[] = [
  {
    type: 'item',
    active: true,
    groups: [],
    label: '',
    subLabel: '',
    id: 'profile-info',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.SettingsRegular,
    label: 'Settings',
    id: 'settings',
    size: 'xs',
  },
  {
    type: 'item',
    active: false,
    icon: Icon.EarthRegular,
    label: 'Region',
    id: 'region',
    size: 'xs',
    groups: [
      {
        id: 'group-1',
        items: [
          {
            type: 'item',
            active: true,
            groups: [],
            label: 'Europe',
            id: 'region-europe',
            iconSize: 20,
          },
          {
            type: 'item',
            active: true,
            groups: [],
            label: 'North america',
            id: 'region-na',
            selected: true,
            iconSize: 20,
          },
        ],
      },
    ],
  },
  {
    id: 'sep-1',
    type: 'separator',
  },
  {
    type: 'item',
    icon: Icon.ArrowExitRegular,
    iconSize: 20,
    active: true,
    groups: [],
    label: 'Logout',
    id: 'logout',
  },
]
